export default {
    stageBorderWidth: 48,
    stageBorderWidthVisible: 68,

    waveConfiguration: {
        style: 'line',
        color: "#d4c6a1",
        backgroundColor: '#ffffff',
        transparency: 0,
        cropLeft: 0,
        cropRight: 100,
        barGap: 4,
        barRadius: 0,
        barWidth: 0, // will be set to 5 in index.html when "bar" style is checked
        barHeight: .3,
        barMinHeight: 1,
    },

    defaultsBarStyle: {
        barGap: 6,
        barWidth: 2
    },

    // overwrite waveConfigurations with these values when theme 'love' is selected
    //
    loveWaveConfigurations: {
        0 : {
            style: 'love'
        },
        1: {
            style: 'love'
        },

    },

    textConfiguration: {
        text: "",
        x: 50,
        y: 80,
        fontSize: 30,
        fontFamily: 'Prata',
        fill: '#000',
        draggable: true,
        scaleX: 1.6,
        scaleY: 1.6,
        label: 'Name',
        dragged: false,
        transformer: null
    },

    transformerConfiguration: {
        anchorSize: 30,
        anchorFill: '#bc6c25',
        borderStroke: '#bc6c25',
        anchorStrokeWidth: 0
    },

    state: {
        // the current step number in the configurator
        step: 0,
        substep: 1,
        availableSubsteps: [0, 0, 3, 0, 2, 0],
        // a unique identifier for this configuration
        uniqueId: null,
        openingStep: null,
        stepQrOpened: false,
        cropModeActive: false,
        loaderPercentage: 0,
        cartBtnClicked: false,
        // the selected theme (classic/love/family)
        theme: {
            title: '',
            price: null,
            maxRecordings: 1
        },
        //------------------------------------------
        // Configured parameters for the image
        //------------------------------------------
        soundFiles: [],
        // settings for each wavesurfer wave
        wavesurferWaves: [], // waves generated with wavesurfer.js
        waveConfigurations: [],

        stage: null, // Konvas object
        stageConfiguration: {
            scaling: 1, // when the scaling is bigger the resulting canvas will be bigger
            format: '3-2', // 4-3, 3-2 or panorama
            orientation: 'landscape',
            border: 'free',
            color: '#d4c6a1',
            customTextColor: null,
            borderColor: '#d4c6a1',
            borderColor2: null,
            fontFamily: 'Prata',
            background: {
                type: '',
                image: '',
                text: '',
                textarea: '',
                text_x: 50,
                text_y: 80,
                text_size: 35,
                text_scaleX: 1,
                text_scaleY: 1,
                effect: 'none',
                transform: null,
                color: '#ffffff',
                text_style: false,
                transformer: null,
                text_transparency: 0,
                text_fill: '#000000',
                imageTransformer: null,
                text_fontFamily: 'Prata',
            }
        },

        // texts
        textConfigurations: [],

        // qrcode
        qrcode: {
            use: true,
            voice: true,
            position: 'top-left',
            usePassword: false,
            password: '',
            price: 0,
            instance: null,
        },
        // additional sound file
        extraSound: {
            use: false,
            price: 9.90,
            soundFile: null,
            videoFile: null,
            type: null
        },
        // copy via digital download
        digitalDownload: {
            use: false,
            price: 9.90
        },
        selectedFrameSize: null,
        selectedMaterial: null
    }
};
